module.exports = __webpack_public_path__ + "static/media/GET_CODE_COPIED_IMAGE.afc66af0.webp";